import React from 'react'
import { Link } from 'react-router-dom';

const Save = () => {
  return (
    <>
      <div className="w-[8.6rem] bg-[#FCD890] font-normal text-[.9rem] px-2 text-[#1E1E1E]">
        <small>CAPISAVE</small>
      </div>
      <div className="md:flex gap-[4rem] items-center justify-center">
        <div className="flex-1 md:mt-[2.5rem] mt-8">
          <h1 className="md:text-[2.75rem] text-[2rem] text-[#1E1E1E] leading-9 font-extrabold md:leading-[52.56px]">
            Reach your goals faster and easier
          </h1>
          <p className="mt-4 text-[1.25rem] text-[#333333] font-normal leading-[29px]">
            Our products and services are designed to ease you into the life
            you’ve always wanted.
          </p>
          <div className="grid grid-cols-2 my-[23px] gap-[2rem]">
            <div className="flex gap-[.7rem] items-start">
              <div className="shrink">
                <svg
                  width="30"
                  height="24"
                  viewBox="0 0 30 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M27.6179 10.4608C27.8963 10.3471 28.1984 10.1885 28.5198 10.101C29.1797 9.92056 29.6602 10.2498 29.729 10.9443C29.7645 11.3008 29.7634 11.6869 29.6591 12.0205C29.5989 12.214 29.3012 12.3311 29.1099 12.482C28.9777 12.2786 28.7863 12.0904 28.7315 11.8673C28.6756 11.6388 28.753 11.3763 28.7734 11.1116C27.9253 11.3292 27.6061 11.6934 27.5448 12.4579C27.3008 15.5148 26.2614 18.1801 23.8977 20.2089C23.7773 20.3117 23.7268 20.5534 23.7225 20.7328C23.7043 21.5881 23.7043 22.4433 23.7182 23.2986C23.7257 23.7787 23.529 24.0018 23.0486 23.9964C22.0113 23.9854 20.974 23.9822 19.9368 23.9986C19.5541 24.004 19.3338 23.8465 19.2209 23.4845C19.0747 23.0175 18.8973 22.5593 18.7694 22.0868C18.677 21.7488 18.5244 21.6493 18.1664 21.6734C16.6691 21.774 15.1696 21.868 13.6702 21.891C12.7812 21.9052 11.8912 21.7838 10.9399 21.7193C10.8292 22.2454 10.7013 22.7868 10.6057 23.3347C10.524 23.8094 10.2907 24.0095 9.80164 23.9997C8.56767 23.9756 7.33369 23.9942 6.09972 23.9898C5.47736 23.9876 5.35375 23.8575 5.3516 23.2155C5.34837 22.2869 5.36342 21.3584 5.33977 20.4309C5.33547 20.2406 5.24733 20 5.11405 19.8721C4.13697 18.9304 3.46302 17.7842 2.84496 16.5855C2.65793 16.2224 2.34513 15.902 2.02804 15.6395C1.62818 15.3092 1.17565 15.0379 0.724201 14.7809C0.365189 14.5775 0.244801 14.2986 0.250175 13.8928C0.266299 12.6012 0.266299 11.3085 0.250175 10.0168C0.244801 9.60886 0.361964 9.32887 0.736025 9.13966C2.06781 8.46376 3.30931 7.68178 4.03163 6.26654C4.19179 5.95265 4.45299 5.66282 4.73139 5.44627C5.30108 5.00223 5.31935 4.45101 5.21616 3.80245C5.0646 2.85203 4.98076 1.89068 4.86252 0.933697C4.81738 0.571685 4.93239 0.320135 5.3043 0.252326C6.66726 0.00296459 8.03775 -0.147965 9.39855 0.222797C10.4691 0.514813 11.3011 1.11197 11.6967 2.23738C11.744 2.37081 12.046 2.48127 12.2309 2.48236C14.3946 2.49768 16.5595 2.5108 18.7232 2.4769C19.6218 2.46268 20.4484 2.65407 21.2653 3.01609C23.6451 4.0715 25.6434 5.56657 26.7806 8.01754C27.1353 8.78093 27.3342 9.6198 27.6179 10.4619V10.4608ZM15.4674 6.39997C16.538 6.39997 17.6075 6.39559 18.6781 6.40215C19.0414 6.40434 19.3488 6.31029 19.3488 5.88812C19.3488 5.45064 19.0188 5.39815 18.6662 5.39815C16.5261 5.40252 14.385 5.40143 12.2449 5.39815C11.8934 5.39815 11.5688 5.45283 11.5763 5.89906C11.5838 6.33544 11.9041 6.39997 12.2567 6.39887C13.3273 6.39559 14.3968 6.39778 15.4674 6.39778V6.39997ZM5.55153 8.60813C5.55153 8.60813 5.55153 8.61141 5.55153 8.61251C5.69449 8.61251 5.87077 8.6661 5.97288 8.60157C6.17174 8.4747 6.32975 8.28112 6.50495 8.11488C6.34265 7.94973 6.20613 7.69599 6.01373 7.64131C5.73318 7.56147 5.39352 7.56037 5.1162 7.64787C4.93562 7.70474 4.72924 7.96723 4.70774 8.15862C4.69269 8.29096 4.95496 8.48892 5.1291 8.59719C5.23336 8.66172 5.40749 8.60923 5.55045 8.60923L5.55153 8.60813Z"
                    fill="#E21F27"
                  />
                </svg>
              </div>
              <div>
                <h3 className="text-[.9rem] font-extrabold">
                  Effortless Savings
                </h3>
                <p className="text-[12px] text-[#333333]">
                  Be in control and save on your own terms.
                </p>
              </div>
            </div>
            <div className="flex gap-[.7rem] items-start">
              <div className="shrink">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_539_721)">
                    <path
                      d="M21.9796 8.41623C25.0955 12.4944 25.5103 19.4018 21.0797 24.2199C16.6338 29.0553 9.32145 29.2745 4.54199 24.7449C-0.126983 20.3205 -0.542528 12.6891 3.61709 7.72896C7.87052 2.65556 14.9223 2.23728 19.6232 5.93975C19.471 6.10129 19.3237 6.25994 19.1736 6.41644C18.7414 6.86717 18.2967 7.30636 17.8797 7.77151C17.6991 7.97344 17.5754 7.96118 17.3613 7.82271C12.2372 4.50895 5.54819 7.22126 3.93744 13.261C2.52264 18.5652 5.91996 24.0345 11.1643 24.8956C16.2565 25.7314 20.9588 22.0304 21.5168 16.7212C21.7412 14.5894 21.2993 12.5939 20.1986 10.7716C20.0624 10.5458 20.0652 10.4211 20.2521 10.2328C20.8379 9.64149 21.4028 9.02778 21.9803 8.41695L21.9796 8.41623Z"
                      fill="#E21F27"
                    />
                    <path
                      d="M19.1889 11.3391C21.0589 14.1747 21.0262 18.8046 17.8679 21.7715C14.777 24.6749 10.0851 24.5862 7.10613 21.5941C4.12018 18.5948 3.89434 13.7103 6.61345 10.4095C9.34368 7.09503 13.841 6.80368 16.8158 8.86622C16.1682 9.53762 15.5296 10.2098 14.8736 10.8624C14.8118 10.9237 14.6255 10.8963 14.5164 10.8545C12.6368 10.1355 10.8968 10.3879 9.33742 11.6997C7.77948 13.0108 7.15755 15.2197 7.735 17.2281C8.31107 19.233 10.0024 20.702 12.0016 20.9342C15.8402 21.3799 18.7205 17.4539 17.2703 13.7391C17.1807 13.5084 17.205 13.3858 17.3704 13.2192C17.9847 12.6026 18.5823 11.9694 19.1896 11.3384L19.1889 11.3391Z"
                      fill="#E21F27"
                    />
                    <path
                      d="M20.7205 6.37242C20.6045 5.51568 20.4808 4.75845 20.4106 3.99474C20.3904 3.77334 20.4578 3.47694 20.5954 3.31828C21.5009 2.27548 22.4369 1.26152 23.3604 0.235297C23.5445 0.0304857 23.7586 -0.0582177 24.0143 0.040582C24.2714 0.140103 24.3631 0.357895 24.3847 0.634102C24.4451 1.4108 24.5299 2.18605 24.582 2.96347C24.5987 3.20794 24.7064 3.25482 24.9072 3.27213C25.6556 3.33559 26.4061 3.39112 27.1496 3.49785C27.3449 3.52598 27.5777 3.6868 27.6847 3.85916C27.8258 4.0856 27.7194 4.33945 27.52 4.53273C26.5228 5.49981 25.5368 6.47843 24.5264 7.42965C24.3867 7.5609 24.1275 7.63158 23.9344 7.61283C23.268 7.54648 22.6057 7.43542 21.9442 7.32436C21.6628 7.27676 21.4578 7.32797 21.241 7.55441C18.5768 10.3388 15.9 13.1103 13.2261 15.8846C13.1365 15.9776 13.0517 16.0829 12.9461 16.1507C12.6882 16.3151 12.4318 16.2935 12.2248 16.057C12.0295 15.8341 12.0295 15.5767 12.1872 15.3293C12.2498 15.2312 12.3436 15.1533 12.4249 15.069C15.1148 12.2766 17.8054 9.48498 20.4926 6.69046C20.5968 6.58156 20.6712 6.44165 20.7205 6.37098V6.37242Z"
                      fill="#E21F27"
                    />
                    <path
                      d="M13.9112 11.8864C13.1003 12.7273 12.3144 13.5386 11.5326 14.3542C11.1157 14.7891 10.9211 15.3084 11.0309 15.9249C11.1532 16.6122 11.5423 17.0767 12.1768 17.2887C12.814 17.5014 13.3928 17.3442 13.8702 16.8581C14.5971 16.1189 15.3114 15.366 16.032 14.6204C16.1119 14.5374 16.1974 14.461 16.2864 14.3759C16.9472 15.9257 16.3051 18.0163 14.8605 19.0714C13.3227 20.1943 11.2547 20.0363 9.88225 18.6928C8.53208 17.3709 8.26246 15.2305 9.23948 13.584C10.2075 11.952 12.1733 11.2193 13.9119 11.8864H13.9112Z"
                      fill="#E21F27"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_539_721">
                      <rect
                        width="27"
                        height="28"
                        fill="white"
                        transform="translate(0.75 0.000244141)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div>
                <h3 className="text-[.9rem] font-extrabold">
                  Set Unlimited Goals
                </h3>
                <p className="text-[12px] text-[#333333]">
                  Save for whatever you want, wherever you want.
                </p>
              </div>
            </div>
            <div className="flex gap-[.7rem] items-start">
              <div className="shrink">
                <svg
                  width="29"
                  height="27"
                  viewBox="0 0 29 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_539_630)">
                    <path
                      d="M22.6957 2.59584C22.0429 3.22153 21.412 3.82336 20.7453 4.4623C20.682 4.42784 20.5608 4.36421 20.4451 4.29528C13.4313 0.116944 4.34864 4.30853 3.33762 12.188C2.56902 18.1718 7.13101 23.6519 13.3707 24.2404C19.6131 24.8317 25.1283 20.4333 25.6737 14.4415C25.8114 12.9224 25.6296 11.4483 25.12 10.014C25.0181 9.72233 25.0594 9.5447 25.2715 9.32995C25.85 8.74138 26.4037 8.13425 26.974 7.52712C29.5415 11.9494 29.1916 19.2323 23.4478 23.8348C17.6957 28.4453 9.28252 27.8938 4.18886 22.6073C-0.767066 17.4639 -0.71748 9.322 4.26599 4.25816C9.48913 -1.04429 17.558 -1.15299 22.6957 2.59584Z"
                      fill="#E21F27"
                    />
                    <path
                      d="M14.2439 12.97C15.434 11.8167 16.4836 10.7934 17.5387 9.77794C20.1916 7.22215 22.8445 4.66637 25.5001 2.11589C26.3266 1.32318 27.5139 1.45839 28.1337 2.40488C28.558 3.04913 28.4753 3.66421 27.861 4.32171C26.5001 5.77989 25.1365 7.23276 23.7728 8.68563C21.0235 11.6179 18.2742 14.5475 15.5304 17.4824C15.2191 17.8165 14.8748 18.0604 14.3927 18.0683C13.9188 18.0789 13.5277 17.9278 13.2357 17.5487C12.007 15.95 10.7673 14.3566 9.54144 12.7579C8.97394 12.0182 9.08414 11.1301 9.78937 10.5415C10.4643 9.97678 11.3183 10.0059 12.0098 10.6767C12.7591 11.4031 13.4698 12.1693 14.2439 12.9674V12.97Z"
                      fill="#E21F27"
                    />
                    <path
                      d="M21.4367 19.6511C21.4367 20.1389 20.8471 20.5021 20.4229 20.2237C20.0785 19.9984 19.7645 19.6908 19.5221 19.3621C19.2245 18.9591 19.5827 18.3891 20.0978 18.3758C20.5248 18.3652 21.4367 19.2322 21.4367 19.6484V19.6511Z"
                      fill="#E21F27"
                    />
                    <path
                      d="M13.6378 21.7376C13.635 21.0165 13.8416 20.7036 14.321 20.693C14.8168 20.6851 15.0427 21.0138 15.0427 21.7562C15.0427 21.9073 15.0537 22.061 15.0317 22.2122C14.9794 22.6125 14.6846 22.8723 14.3017 22.8432C13.8912 22.814 13.6846 22.5701 13.6378 22.1936C13.6185 22.0425 13.635 21.8887 13.635 21.7376H13.6378Z"
                      fill="#E21F27"
                    />
                    <path
                      d="M15.0399 5.21782C15.0399 5.33977 15.0509 5.46438 15.0399 5.58368C14.9958 5.99462 14.7176 6.24914 14.3319 6.24649C13.9435 6.24384 13.6708 5.98137 13.6432 5.56778C13.6267 5.32386 13.6294 5.0773 13.6432 4.83339C13.6625 4.38798 13.927 4.1096 14.3264 4.1043C14.7314 4.09635 15.0096 4.36147 15.0454 4.80422C15.0564 4.94209 15.0454 5.07995 15.0454 5.21782H15.0399Z"
                      fill="#E21F27"
                    />
                    <path
                      d="M22.9355 14.1313C22.7757 14.1313 22.6159 14.1419 22.4589 14.1313C22.0401 14.0942 21.8308 13.8582 21.8335 13.4659C21.8335 13.0894 22.0456 12.8587 22.4368 12.8296C22.7674 12.8057 23.1035 12.811 23.4368 12.8243C23.8556 12.8402 24.0704 13.0867 24.1035 13.4685C24.1338 13.8264 23.8253 14.1101 23.412 14.1366C23.255 14.1472 23.0952 14.1366 22.9355 14.1366C22.9355 14.1366 22.9355 14.1366 22.9355 14.134V14.1313Z"
                      fill="#E21F27"
                    />
                    <path
                      d="M7.91319 20.3086C7.38702 20.2953 7.03992 19.7465 7.34019 19.3329C7.5716 19.0148 7.87187 18.7205 8.20245 18.5005C8.36774 18.3918 8.70934 18.4024 8.89942 18.4952C9.06746 18.58 9.20521 18.8451 9.23 19.044C9.2851 19.4655 8.35948 20.3166 7.91595 20.3059L7.91319 20.3086Z"
                      fill="#E21F27"
                    />
                    <path
                      d="M9.24952 8.04675C9.18616 8.13159 9.08974 8.38345 8.91068 8.46299C8.71233 8.55048 8.379 8.56904 8.2082 8.46299C7.88313 8.25619 7.58836 7.96986 7.37349 7.65967C7.2633 7.49794 7.27432 7.16919 7.37349 6.98626C7.46164 6.82453 7.73712 6.69197 7.94649 6.67076C8.379 6.62569 9.24401 7.48999 9.24952 8.04675Z"
                      fill="#E21F27"
                    />
                    <path
                      d="M5.73429 14.1286C5.56073 14.1286 5.38442 14.1445 5.21087 14.126C4.81142 14.0862 4.62134 13.8396 4.62134 13.4764C4.62134 13.1079 4.81693 12.8587 5.21087 12.8295C5.54145 12.803 5.87754 12.8056 6.20811 12.8242C6.63511 12.8481 6.90233 13.1185 6.87478 13.5003C6.84999 13.8926 6.61858 14.11 6.20811 14.1339C6.05109 14.1419 5.89131 14.1339 5.73153 14.1339C5.73153 14.1339 5.73153 14.1313 5.73153 14.1286H5.73429Z"
                      fill="#E21F27"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_539_630">
                      <rect
                        width="28"
                        height="26.963"
                        fill="white"
                        transform="translate(0.5 0.000244141)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div>
                <h3 className="text-[.9rem] font-extrabold">
                  Competitive Interest Rate
                </h3>
                <p className="text-[12px] text-[#333333]">
                  Earn amazing returns on your savings.
                </p>
              </div>
            </div>
            <div className="flex gap-[.7rem] items-start">
              <div className="shrink">
                <svg
                  width="29"
                  height="40"
                  viewBox="0 0 29 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_539_752)">
                    <path
                      d="M14.9585 7.40345C22.0485 7.40835 27.8038 13.1106 27.787 20.1143C27.7696 27.1186 22.0236 32.7913 14.9499 32.7864C7.8618 32.7821 2.104 27.0762 2.12138 20.075C2.13875 13.0713 7.88538 7.39854 14.9585 7.40345ZM5.78453 20.086C5.77957 25.0759 9.88324 29.1496 14.93 29.1643C19.9879 29.1791 24.1189 25.1078 24.1245 20.1038C24.1301 15.1128 20.0276 11.0409 14.979 11.0262C9.92295 11.0114 5.78949 15.0839 5.78453 20.086Z"
                      fill="#E21F27"
                    />
                    <path
                      d="M13.1178 18.2869C13.1178 17.685 13.1035 17.0824 13.1209 16.4805C13.1495 15.4932 13.8183 14.7716 14.7844 14.6599C15.6325 14.5617 16.4745 15.125 16.709 15.9687C16.7686 16.1816 16.7866 16.4111 16.789 16.6339C16.7983 17.45 16.7816 18.2667 16.8021 19.0828C16.8064 19.2429 16.8951 19.4362 17.0093 19.5516C17.9691 20.5217 18.9532 21.4685 19.9112 22.4404C20.84 23.3835 20.5372 24.9138 19.3329 25.379C18.6088 25.6581 17.9139 25.5606 17.3512 25.0175C16.0966 23.8051 14.8638 22.5705 13.6272 21.3402C13.258 20.9727 13.1172 20.5112 13.1172 20.0019C13.1172 19.4307 13.1172 18.8588 13.1172 18.2875H13.1184L13.1178 18.2869Z"
                      fill="#E21F27"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_539_752">
                      <rect
                        width="25.6656"
                        height="25.3836"
                        fill="white"
                        transform="translate(2.12158 7.40344)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div>
                <h3 className="text-[.9rem] font-extrabold">
                  Real-time Monitoring
                </h3>
                <p className="text-[12px] text-[#333333]">
                  Track your savings growth on the go.
                </p>
              </div>
            </div>
          </div>
          <div className="flex my-[2.5rem] md:gap-[2rem] gap-4">
            <Link
              to="/product/capisave"
              className="bgGradient px-[1.8rem] py-[11px] text-white font-semibold text-.9rem]"
            >
              Apply Now
            </Link>
            <Link
              to="/product/capisave"
              className="px-[1.8rem] py-[11px] text-[#1E1E1E] border-2 border-[#1E1E1E] rounded-2xl font-semibold text-[.9rem]"
            >
              Learn More
            </Link>
          </div>
        </div>
        <div className="flex-1">
          <div className="max-w-[28rem] h-[364px]">
            <img
              src="/images/save.png"
              alt="save"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Save
